module.exports = __webpack_public_path__ + "static/media/selection-bg-1.a19c7741.svg";